import { styled as r } from "./styled2.mjs";
import "@mui/material";
import { Typography as e } from "./index59.mjs";
const l = r(e.TextMd.Regular)`
	color: ${({ theme: o }) => o.palette.secondary.main30};
`;
export {
  l as StyledPlacehoder
};
//# sourceMappingURL=styles110.mjs.map
